import { Transacao } from './transacao.model'

export class Recebimento extends Transacao {
    tipoDeOperacao: string
    valorDeAjuste: number

    get possuiValorDeAjuste() {
        return this.valorDeAjuste && this.valorDeAjuste > 0
    }

    get descricaoOperacao() {
        if( this.tipoDeOperacao === 'Cancelamento'){
            return this.tipoDeOperacao;
        }

        return this.possuiValorDeAjuste ? this.tipoDeOperacao : this.tipoDeVenda
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/recebimento.model.ts